import { Checkbox as SemanticCheckbox } from 'semantic-ui-react';
import styled from 'styled-components';

const Ranges = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  div {
    display: flex;
    flex-direction: column;

    span {
      font-size: 14px;
      margin-top: 5px;
    }
  }

  @media screen and (max-width: 420px ) {
    flex-wrap: wrap;
    justify-content: flex-start;
  };
`;

const RangeRadioContainer = styled.div`
  label {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-content: center;
    align-self: center;
    cursor: pointer;
  }
`;

const Difficulty = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
  margin-bottom: 5px;

  @media screen and (max-width: 420px ) {
    flex-wrap: wrap;
  };
`;

const Label = styled.span`
  font-size: 12px;
`;

const Checkbox = styled(SemanticCheckbox)`
  &&& {
    margin: 0 0 1em;
  }
`;

export {
  Difficulty,
  RangeRadioContainer,
  Ranges,
  Label,
  Checkbox,
};
